/* eslint-disable no-param-reassign */
/**
 * @page email Setting store
 * @author kohei.sato
 * @Date 2019/12/09
 */

import { observable, action, configure, makeAutoObservable } from 'mobx';

import emailSettingService from '_common/service/emailSettingService';

configure({
  enforceActions: 'always',
});

export default class emailSettingStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      settingInfoList: observable,
      settingStatusList: observable,
      getSettingInfo: action,
      saveSettingInfo: action,
      switchRadioSelection: action,
      switchAllToNotReceive: action,
      switchCategorySelection: action,
      setSettingInfoList: action,
      setSettingStatusList: action,
    });

    this.rootStore = rootStore;
  }

  settingInfoList = [];

  settingStatusList = [];

  async getSettingInfo() {
    const res = await emailSettingService.getEmailSettingInfo();
    this.setSettingInfoList(res);
    let isAllNotReceive = true;
    const newSettingStatusList = this.settingInfoList.map((item) => {
      if (item.id != -1 && item.permission_flg == 1) {
        isAllNotReceive = false;
      }
      const newItem = {
        itemKey: `${item.group_id}-${item.id}`,
        group_id: item.group_id,
        id: item.id,
        msg_title: item.msg_title,
        msg_key: item.msg_key,
        permission_flg: item.permission_flg,
      };
      return newItem;
    });
    const allSettingItem = newSettingStatusList.find((item) => {
      return item.group_id == 0 && item.id == -1;
    });
    if (allSettingItem) {
      allSettingItem.permission_flg = isAllNotReceive ? 1 : 0;
    }
    this.setSettingStatusList(newSettingStatusList);
  }

  async saveSettingInfo() {
    const msgKeyValueList = this.settingStatusList
      .filter((item) => {
        return item.msg_key != 'CATEGORY';
      })
      .map((item) => {
        const newItem = {
          key: item.msg_key,
          value: item.permission_flg,
        };
        return newItem;
      });
    emailSettingService.saveEmailSettingInfo(msgKeyValueList);
  }

  switchRadioSelection(itemKey) {
    let shouldUncheckAllSetting = false;
    this.settingStatusList.forEach((item) => {
      if (item.itemKey === itemKey) {
        if (item.permission_flg == 0) {
          // 「受信する」を選択したとき
          item.permission_flg = 1;
          shouldUncheckAllSetting = true;
        } else {
          // 「受信しない」を選択したとき
          item.permission_flg = 0;
        }
      }
    });
    if (shouldUncheckAllSetting) {
      const allSettingItem = this.settingStatusList.find((item) => {
        return item.group_id == 0 && item.id == -1;
      });
      if (allSettingItem) {
        allSettingItem.permission_flg = 0;
      }
    }
  }

  switchAllToNotReceive() {
    let shouldSwitchAllRadioToNotReceive = false;
    const allSettingItem = this.settingStatusList.find((item) => {
      return item.group_id == 0 && item.id == -1;
    });
    if (allSettingItem.permission_flg == 0) {
      // 「全て受信しない」をチェックしたとき
      allSettingItem.permission_flg = 1;
      shouldSwitchAllRadioToNotReceive = true;
    } else {
      // 「全て受信する」のチェックを解除したとき
      allSettingItem.permission_flg = 0;
    }
    if (shouldSwitchAllRadioToNotReceive) {
      this.settingStatusList.forEach((item) => {
        if (item.id != -1) {
          item.permission_flg = 0;
        }
      });
    }
  }

  switchCategorySelection(itemKey, selectionNum) {
    // eslint-disable-next-line
    let groupId = itemKey.replace('-top', '');
    const newValueForItem = selectionNum;
    const newValueForCategoryTop = selectionNum == 0 ? 1 : 0;
    this.settingStatusList.forEach((item) => {
      if (groupId == item.group_id) {
        if (item.id == -1) {
          item.permission_flg = newValueForCategoryTop;
        } else {
          item.permission_flg = newValueForItem;
        }
      }
    });
  }

  setSettingInfoList(list) {
    this.settingInfoList = list;
  }

  setSettingStatusList(list) {
    this.settingStatusList = list;
  }
}
